import React from 'react';
import { LoadingModalRef } from 'src/components/LoadingModal';
class LoadingService {
  static instance: React.MutableRefObject<LoadingModalRef>;
}

export default LoadingService;
